import { render, staticRenderFns } from "./max.vue?vue&type=template&id=b7f4b8d2"
import script from "./max.vue?vue&type=script&lang=js"
export * from "./max.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports